export enum Components {
  GGC_DATASET_SWITCHER = "ggc-dataset-switcher",
  GGC_DATASET_TREE = "ggc-dataset-tree",
  GGC_LEGEND = "ggc-legend",
  GGC_MAP = "ggc-map",
  GGC_SEARCH_LOCATION = "ggc-search-location",
  GGC_TOOLBAR = "ggc-toolbar"
}
